import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const SellingAttributePlaceholder = () => (
  <div className="flex flex-row">
    <Placeholder
      type="rect"
      loading
      className="shrink-0 !w-[42px] !h-[42px] !mr-0"
    />
    <Placeholder
      type="rect"
      loading
      className="!w-full !h-[42px] !ml-[10px] !mr-0"
    />
  </div>
);

const PDPSellingAttributesPlaceholder = () => (
  <div className="flex flex-col border-t border-solid border-gray-light6 mt-14 pt-14 !w-full !h-60">
    <Placeholder type="text" loading row={1} className="!w-[115px] !h-6" />
    <div className="flex flex-col space-y-1">
      <SellingAttributePlaceholder />
      <SellingAttributePlaceholder />
      <SellingAttributePlaceholder />
    </div>
  </div>
);

export default PDPSellingAttributesPlaceholder;
